 
import React, { ReactElement } from 'react';

import { SkeletonBase } from '@digital-dealer/components';

const MobileSkeleton = (): ReactElement => (
  <SkeletonBase viewBox="0 0 375 1142">
    <rect
      x="16"
      y="334"
      width="181.122"
      height="24"
      rx="4"
    />
    <rect
      x="16"
      y="371"
      width="343"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="399"
      width="163.01"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="473"
      width="181.122"
      height="24"
      rx="4"
    />
    <rect
      x="16"
      y="510"
      width="343"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="538"
      width="163.01"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="612"
      width="181.122"
      height="24"
      rx="4"
    />
    <rect
      x="16"
      y="649"
      width="343"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="677"
      width="163.01"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="751"
      width="181.122"
      height="24"
      rx="4"
    />
    <rect
      x="16"
      y="788"
      width="343"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="816"
      width="163.01"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="890"
      width="181.122"
      height="24"
      rx="4"
    />
    <rect
      x="16"
      y="927"
      width="343"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="955"
      width="163.01"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="1029"
      width="181.122"
      height="24"
      rx="4"
    />
    <rect
      x="16"
      y="1066"
      width="343"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="1094"
      width="163.01"
      height="16"
      rx="4"
    />
    <rect
      x="16"
      y="70"
      width="132"
      height="24"
      rx="4"
    />
    <rect
      x="16"
      y="106"
      width="343"
      height="196"
      rx="4"
    />
  </SkeletonBase>
);

export default MobileSkeleton;
